import makeGrid from "./makeGrid";


// ! rename the function to align with the widget name
export const sonataVariationTable = async () => {
    const el = document.querySelector('.curious-sonata-variation-table');
    if (!el) return;

    // ------------------------------------------------------------
    const loadingStates = document.querySelectorAll('.table-container');
    const endpoint = el.getAttribute('data-endpoint');
    if (!endpoint) {
        console.error('No endpoint specified for the sonata-variant-analysis-table widget');
        return;
    }
    const url = `${window.apiUri}${endpoint}/meta`
    try {
        const response = await fetch(url)
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`)
        }
        const data = await response.json();

        makeGrid(data)

        loadingStates.forEach(container => container.classList.remove('loading'))

    } catch(error) {
        el.style.display = 'none';
        let to_hide = document.querySelectorAll('.table-container.loading, .curious-sonata-detailed-comparisons.loading, .curious-sonata-line-chart, .curious-data-disclaimer, .needs_data');

        to_hide.forEach(element => {
            element.style.display = 'none';
        });
        console.warn(`Failed to fetch ${url}: ${error} - hiding table`);
    }

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

